import './MainContent.scss';

import React, { FC } from 'react';
import { ModuleDeclaration } from 'modules/ModuleDeclaration';

interface MainContentProps {
  children: any;
  modules: ModuleDeclaration[];
}

const MainContent: FC<MainContentProps> = ({ children, modules }) => {
  const currModule = modules.find(m => m.routeProps.path && window.location.href.toLowerCase().includes(m.routeProps.path.toLocaleLowerCase()))
  return (
  <div className={currModule?.containerCss ?? 'py-5 mb-5 border-bottom container'}>{children}</div>
);
}

export default MainContent;
